export const dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
export const cpfMask = [/^\d{3}\.\d{3}\.\d{3}\-\d{2}$/];
export const errorQueue = {
    title: 'Tivemos problemas ao solicitar essa análise',
    message: 'Ops, parece que outra pessoa está com essa análise',
    type: 'queue',
    button: 'Voltar'
}

export const ErroEvent = {
    title: 'Tivemos um problema ao validar essa ação',
    message: 'Ops, parece que outra pessoa está com essa análise',
    type: 'queue',
    button: 'Voltar'
}